/* Goloso Sano — theme interactions */
(function () {
  "use strict";

  var themeConfig = window.theme || {};
  var themeStrings = themeConfig.strings || {};
  var themeRoutes = themeConfig.routes || {};

  /* ---- Mobile nav ---- */
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.getElementById("SiteNav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll("[data-faq]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var panel = btn.nextElementSibling;
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      panel.style.maxHeight = open ? null : panel.scrollHeight + "px";
    });
  });

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---- Live cart count (AJAX add) ---- */
  /* Adds once, then gives the cart drawer app a bounded chance to open.
     If no drawer opens, fall back to the cart page. */
  var DRAWER_SEL = '[data-essential-cart-element="cart-drawer-overlay"]';
  var DRAWER_WAIT_MS = 1200;
  var DRAWER_POLL_MS = 100;
  var adding = false;

  /* Shopify serves the cart routes under the active locale prefix, which is
     "/" on the Italian storefront and "/en/" on the English one. */
  var CART_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var CART_ADD_URL = CART_ROOT + "cart/add.js";
  var CART_URL = CART_ROOT + "cart.js";

  function drawerIsOpen() {
    var el = document.querySelector(DRAWER_SEL);
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden") return false;
    if (parseFloat(cs.opacity) === 0) return false;
    /* The drawer is fixed positioned, so offsetParent is always null.
       Check that it actually occupies space inside the viewport instead. */
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    return r.right > 0 && r.left < window.innerWidth;
  }

  function openDrawerOrGoToCart() {
    /* Essent exposes an open call. Without it, a second click on a buy button
       (the single copy already in the cart, Shopify answers 422) left the
       visitor on the page with nothing happening: the nudges below did not
       open the drawer. */
    var api = window.essentialCartApi;
    if (api && typeof api.openCart === "function") {
      try { api.openCart(); return; } catch (err) { /* fall through to the nudges */ }
    }

    /* Nudge the drawer app with the events it commonly listens for. */
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

    var waited = 0;
    var link = document.querySelector(".cart-link");
    var nudged = false;

    (function poll() {
      if (drawerIsOpen()) return;
      waited += DRAWER_POLL_MS;
      if (!nudged && waited >= 400 && link) {
        nudged = true;
        /* The cart link is a real anchor. Cancel its default in the capture
           phase so the drawer app still opens but the browser does not
           navigate to the cart page. */
        var guard = function (ev) {
          if (ev.target && ev.target.closest && ev.target.closest(".cart-link")) {
            ev.preventDefault();
          }
        };
        document.addEventListener("click", guard, true);
        link.click();
        setTimeout(function () {
          document.removeEventListener("click", guard, true);
        }, 0);
      }
      if (waited >= DRAWER_WAIT_MS) {
        window.location.href = themeRoutes.cart || "/cart";
        return;
      }
      setTimeout(poll, DRAWER_POLL_MS);
    })();
  }

  /* Shopify applies the per item add to cart limit to the items[] body of
     /cart/add.js only. The legacy id + quantity body, and the plain form post
     to /cart/add, are both accepted without the check, so the payload is built
     explicitly. Everything a product form can carry is mapped across: variant
     id, quantity, selling plan and line item properties.

     Returns null when no variant id is present, which the caller treats as
     "cannot be added" rather than falling back to a form post. */
  function buildAddPayload(form) {
    var data = new FormData(form);
    var id = data.get("id");
    if (!id) return null;

    var quantity = parseInt(data.get("quantity"), 10);
    var item = { id: id, quantity: quantity > 0 ? quantity : 1 };

    var sellingPlan = data.get("selling_plan");
    if (sellingPlan) item.selling_plan = sellingPlan;

    var properties = {};
    var hasProperties = false;
    data.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match) { properties[match[1]] = value; hasProperties = true; }
    });
    if (hasProperties) item.properties = properties;

    return { items: [item] };
  }

  /* The cart as Shopify actually holds it, or null when the answer cannot be
     trusted. A caller must never draw a conclusion from a failed read, so an
     unusable response is reported as absence of information rather than as an
     empty cart. Never rejects. */
  function readCart() {
    return fetch(CART_URL, { headers: { Accept: "application/json" } }).then(
      function (r) {
        if (!r.ok) return null;
        return r.json().then(
          function (cart) {
            return cart && Array.isArray(cart.items) ? cart : null;
          },
          function () { return null; }
        );
      },
      function () { return null; }
    );
  }

  /* True only while the store allows a single copy per variant. If that limit
     is ever raised, "present" no longer means "the visitor got what they came
     for" and the decisions below must be revisited. */
  function variantInCart(cart, id) {
    return cart.items.some(function (item) {
      return String(item.variant_id) === String(id) && item.quantity > 0;
    });
  }

  /* Checkout test (Kenay 19-10): visitors who arrive through a link with
     direct=1 skip the cart drawer and go straight to checkout after a
     successful add. The flag is kept for the session, so it survives the
     visitor scrolling or reloading the page. The add itself still goes
     through /cart/add.js, so the cart keeps its attributes (UTM, fbc) for
     attribution. */
  var DIRECT_KEY = "gs_direct_checkout";
  try {
    if (/[?&]direct=1(&|$)/.test(window.location.search)) {
      window.sessionStorage.setItem(DIRECT_KEY, "1");
    }
  } catch (err) { /* storage blocked: the flag only works on the landing URL */ }

  function directCheckout() {
    if (/[?&]direct=1(&|$)/.test(window.location.search)) return true;
    try { return window.sessionStorage.getItem(DIRECT_KEY) === "1"; } catch (err) { return false; }
  }

  /* In the direct variant the cart drawer app (Essent) still opens itself on
     every add. It is hidden for the whole visit so the visitor only sees the
     page and then the checkout; it is shown again only when the add was
     refused and the cart has to explain why. */
  if (directCheckout()) {
    document.documentElement.classList.add("gs-direct");
    var hideDrawer = document.createElement("style");
    hideDrawer.textContent = 'html.gs-direct [data-essential-cart-element="cart-drawer-overlay"]{visibility:hidden!important;opacity:0!important}';
    document.head.appendChild(hideDrawer);
  }

  function afterAdd() {
    if (directCheckout()) {
      window.location.href = CART_ROOT + "checkout";
      return;
    }
    openDrawerOrGoToCart();
  }

  function showCount(cart) {
    var count = document.querySelector("[data-cart-count]");
    if (count) count.textContent = cart.item_count;
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    /* Cancelled before anything else, and never handed back. Shopify does not
       apply the add to cart limit to a plain form post to /cart/add either, so
       falling back to one would reintroduce exactly what this code prevents. */
    e.preventDefault();
    if (adding) return;

    var payload = buildAddPayload(form);
    if (!payload) {
      /* Unreachable while every product is single variant, because both forms
         render a hidden id. A variant that can only be resolved from options[]
         selects cannot be expressed as items[], and the plain form post is not
         a safe alternative, so the add is refused instead. */
      if (window.console) {
        console.warn("[theme] add to cart skipped: the form carries no variant id");
      }
      return;
    }

    adding = true;
    var btn = form.querySelector('[name="add"]');
    var label = btn ? btn.innerHTML : "";
    /* The confirmation is written only once Shopify has accepted the add. */
    if (btn) btn.setAttribute("aria-disabled", "true");

    function release() {
      if (btn) { btn.removeAttribute("aria-disabled"); btn.innerHTML = label; }
      adding = false;
    }

    /* Already in the cart (single copy per variant): open the cart instead of
       posting. A post would be refused with 422 and Essent then shows a red
       "maximum quantity" message in the drawer. An unreadable cart is not a
       reason to skip the add, so only a confirmed presence short-circuits. */
    readCart().then(function (current) {
      if (current && variantInCart(current, payload.items[0].id)) {
        showCount(current);
        release();
        afterAdd();
        return;
      }
      postAdd();
    });

    function postAdd() {
      fetch(CART_ADD_URL, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json", Accept: "application/json" }
      }).then(
        function (r) { return r.ok; },
        /* A failed request says nothing about what the server did with it. The
           post is not idempotent, so the outcome is established by reading the
           cart, never by posting again. */
        function () { return false; }
      )
        .then(function (accepted) {
          return readCart().then(function (cart) {
            /* The badge follows the cart Shopify holds, never an assumption
               about what was just sent. An unreadable cart leaves it alone; the
               next page load or drawer open corrects it. */
            if (cart) showCount(cart);

            /* Null while the cart could not be read, so absence of information
               stays distinct from a genuine absence from the cart. */
            var inCart = cart ? variantInCart(cart, payload.items[0].id) : null;

            /* Confirmed only when Shopify accepted the add and the cart does not
               contradict it. A readable cart without the variant outranks the
               2xx: /cart.js is served uncached and reflects a write immediately,
               so it describes what the visitor actually has. An unreadable cart
               contradicts nothing, so an accepted add still stands. */
            if (accepted && inCart !== false) {
              if (btn) btn.innerHTML = (themeStrings.added || "") + " \u2713";
              if (directCheckout()) { afterAdd(); return; }   /* no pause before checkout */
              setTimeout(function () {
                release();
                afterAdd();
              }, 500);
              return;
            }

            /* Decided on what the cart holds, not on why Shopify refused.
               Shopify answers 422 for the max quantity refusal, for a partly
               filled request that did add one, and for an unknown variant, with
               no machine readable code and a description that is not always
               translated. The cart answers all three. */
            if (inCart) {
              /* The single copy this store allows is in the cart, which is all
                 this button can achieve. Showing it is the honest response, so
                 no confirmation is claimed and no message is invented. */
              release();
              afterAdd();
              return;
            }

            /* The add was refused, or it was accepted but left no trace in the
               cart, or the cart could not be read. Nothing is claimed and
               nothing is retried. With a readable cart the cart is opened, so
               the button never looks dead: a single book from the bundle
               already in the cart makes Shopify refuse the bundle ("già
               esaurito", per item limit of one), and the visitor can see and
               remove it there (Kenay 15-10, option 1). */
            release();
            document.documentElement.classList.remove("gs-direct");   /* show why */
            if (cart) openDrawerOrGoToCart();
          });
        })
        /* Defensive only: readCart never rejects. Must not mutate anything. */
        .catch(function () { release(); });
    }
  });
})();
